import i18next from 'i18next'
import { useEffect } from 'react'

import { markNoticed, pendingUpdate, startUpdate } from '@/shared/lib/appUpdateNotice'
import { notify } from '@/shared/lib/notify'

/** Espera tras abrir la app: no compite con el arranque ni con la primera pantalla. */
export const APP_UPDATE_CHECK_DELAY_MS = 4000

/**
 * Al abrir la app nativa, si la tienda tiene una versión nueva de la que no se ha avisado,
 * aviso amarillo sin caducidad con «Actualizar». Una vez por versión. En web, nada. Se monta una
 * vez desde `App`.
 */
export function useAppUpdateNotice(): void {
  useEffect(() => {
    let cancelled = false
    const timer = setTimeout(() => {
      void pendingUpdate().then((version) => {
        if (cancelled || !version) return
        markNoticed(version)
        notify.info(i18next.t('appUpdate.available'), {
          id: 'app-update',
          duration: Infinity,
          action: { label: i18next.t('appUpdate.cta'), onClick: () => void startUpdate() },
        })
      })
    }, APP_UPDATE_CHECK_DELAY_MS)
    return () => {
      cancelled = true
      clearTimeout(timer)
    }
  }, [])
}
